interface InlineLoadingAlertProps {
  loading: boolean;
  message: string;
}

export const InlineLoadingAlert: React.FC<InlineLoadingAlertProps> = ({
  loading,
  message,
}) => {
  if (!loading) {
    return null;
  }

  return (
    <div className="inline-loading-alert alert alert-warning">{message}</div>
  );
};
